import type { Translations } from './types'

export const sl: Translations = {
  common: {
    stationUnknown: (nr) => `Postaja ${nr} še ni aktivna.`,
    stationOffline: 'Ni povezave — poskusite znova pozneje.',
    toMap: 'Na zemljevid',
    more: 'Več',
    images: 'Slike',
    retry: 'Poskusi znova',
    back: 'Nazaj',
    close: 'Zapri',
    processing: 'Prijava se obdeluje…',
  },

  landing: {
    hero: {
      title: 'Do\u017Eivite naravo v\nraz\u0161irjeni resni\u010Dnosti',
      subtitle: (count) =>
        `Odkrijte rastlinstvo in \u017Eivalstvo soteske Tscheppaschlucht \u2014 ${count} vrst, interaktivno in na dosegu roke.`,
      cta: 'Razišči',
      secondaryCta: 'Ustvari račun',
    },
    intro: {
      heading: 'Soteska\no\u017Eivi',
      text: (count) =>
        `TSCHAPP o\u017Eivlja sotesko Tscheppaschlucht v Ferlachu. Z raz\u0161irjeno resni\u010Dnostjo lahko raziščete več kot ${count} domorodnih \u017Eivalskih in rastlinskih vrst neposredno v njihovem naravnem okolju \u2014 s podrobnimi opisi, z umetno inteligenco ustvarjenimi \u010Dlanki in poglobljenim 3D modelom.`,
    },
    stats: {
      animals: '\u017Divalske vrste',
      plants: 'Rastlinske vrste',
      ar: 'Augmented Reality',
    },
    community: {
      heading: 'Pridru\u017Eite se skupnosti',
      text: 'Z ra\u010Dunom lahko ozna\u010Dite priljubljene vrste, pustite komentarje in do\u017Eivite sotesko Tscheppaschlucht z drugimi ljubitelji narave.',
      features: {
        like: {
          title: 'Ozna\u010Di vrste',
          description:
            'Ozna\u010Dite svoje najljub\u0161e vrste in ustvarite svojo osebno zbirko',
        },
        comment: {
          title: 'Komentiraj',
          description:
            'Delite svoje znanje in se pove\u017Eite z drugimi ljubitelji narave',
        },
        ar: {
          title: 'Do\u017Eivi AR',
          description:
            'Do\u017Eivite vrste v raz\u0161irjeni resni\u010Dnosti kar v soteski',
        },
      },
      registerWithGoogle: 'Registracija z Google',
    },
    routes: {
      heading: 'Tri poti, ena izku\u0161nja',
      text: 'Vse poti se za\u010Dnejo pri obiskovalnem centru in vodijo skozi sotesko Tscheppaschlucht. Na razvili\u0161\u010Du izberete svojo pustolov\u0161\u010Dino.',
      stations: 'Postaje',
      detailLink: 'Vse poti v podrobnostih',
    },
    stories: {
      heading: 'Zgodbe iz soteske',
      text: 'Legende, miti in zgodbe na\u0161ih maskot \u2014 pripovedovane kot interaktivna zvočna knjiga z ilustracijami umetne inteligence.',
      narratorTschauko: 'Pripoveduje Tschauko',
      narratorTschauka: 'Pripoveduje Tschauka',
      scenes: 'Prizori',
      allLink: 'Vse zgodbe',
    },
    featured: {
      heading: 'Izpostavljene vrste',
      discoverLink: (count) => `Odkrijte vseh ${count} vrst`,
    },
  },

  browse: {
    badge: 'Flora & Fauna',
    heroTitle: 'Flora & Fauna',
    heroSubtitle: 'Odkrijte \u017Eivalstvo in rastlinstvo soteske Tscheppaschlucht',
    speciesCount: (count) => `${count} vrst`,
    filterAll: 'Vse',
    logout: 'Odjava',
    login: 'Prijava',
    authBanner: 'Prijavite se, da ozna\u010Dite vrste in pustite komentarje',
    close: 'Zapri',
  },

  species: {
    loading: 'Nalaganje objekta...',
    analyzing: 'Analiziranje objekta...',
    loading3d: 'Nalaganje 3D modela...',
    preparing3d: 'Pripravljam 3D model …',
    load3dFailed: '3D modela ni bilo mogoče naložiti.',
    arStartFailed: 'AR ni bilo mogoče zagnati. Preverite dovoljenje WebXR v brskalniku.',
    notFound: 'Objekt ni najden',
    analysisFailed: 'Analiza ni uspela',
    noId: 'ID ni podan',
    brandSubtitle: 'Do\u017Eivite naravo v raz\u0161irjeni resni\u010Dnosti',
    featuresCount: (count) => `${count} lastnosti`,
    share: 'Deli',
    like: 'V\u0161e\u010Dek',
    unlike: 'Odstrani v\u0161e\u010Dek',
    comments: 'Komentarji',
    audioGuide: {
      label: 'Zvočni vodnik',
      subtitle: 'Poslušaj opis',
      noAudio: 'Brez zvoka',
    },
    pause: 'Premor',
    play: 'Predvajaj',
    stopMusic: 'Ustavi glasbo',
    view2d: '2D pogled',
    view3d: '3D pogled',
    commentsSection: {
      title: (count) => `Komentarji (${count})`,
      empty: 'Še ni komentarjev. Bodite prvi!',
      placeholder: 'Napišite komentar...',
      delete: 'Izbriši',
    },
    close: 'Zapri',
    back: 'Nazaj',
  },

  routes: {
    headerTitle: 'Pohodniške poti',
    heroTitle: 'Tri poti skozi\nsotesko',
    heroSubtitle:
      'Vse poti se za\u010Dnejo pri obiskovalnem centru in vodijo skozi veli\u010Dastno sotesko Tscheppaschlucht. Na razvili\u0161\u010Du se odlo\u010Dite, katera pustolov\u0161\u010Dina vas \u010Daka.',
    stats: {
      kilometers: 'Kilometri',
      walkingTime: '\u010Cas hoje',
      stations: 'Postaje',
    },
    sections: {
      routeCourse: 'Pregled poti',
      elevationProfile: 'Vi\u0161inski profil',
      stations: 'Postaje',
    },
    listToggle: 'Seznam',
    loading3d: 'Nalaganje 3D pogleda\u2026',
    elevationMin: 'min',
    elevationMax: 'maks',
    back: 'Nazaj',
    details: {
      listenDescription: 'Poslušaj opis',
      stopListening: 'Ustavi',
      listenRoute: 'Poslušaj pot',
      guideLive: 'Dr. Tschauko v živo',
      nextStations: 'Naslednje postaje',
    },
  },

  stories: {
    languageFallback: 'Ta pripovedka je zaenkrat na voljo samo v nemščini.',
    badge: 'Legende in zgodbe',
    pageTitle: 'Legende in zgodbe',
    pageSubtitle:
      'Miti in legende soteske Tscheppaschlucht \u2014 pripovedujejo Tschauko & Tschauka',
    narratorTschauko: '\uD83E\uDD89 Pripoveduje Tschauko',
    narratorTschauka: '\uD83D\uDC38 Pripoveduje Tschauka',
    chapterCounter: (current, total) => `Poglavje ${current} od ${total}`,
    chapterCount: (count) => `${count} poglavij`,
    startAudiobook: 'Za\u010Dni zvočno knjigo',
    closeAudiobook: 'Zapri zvočno knjigo',
    previousChapter: 'Prej\u0161nje poglavje',
    nextChapter: 'Naslednje poglavje',
    done: 'Končano',
    chapterN: (n) => `Poglavje ${n}`,
    toggleMode: 'Preklopi na\u010Din',
    photoBackground: 'Foto ozadje',
    back: 'Nazaj',
  },

  footer: {
    tagline:
      'Do\u017Eivite naravo v raz\u0161irjeni resni\u010Dnosti. ',
    legal: {
      title: 'Pravne informacije',
      imprint: 'Impressum',
      privacy: 'Politika zasebnosti',
      terms: 'Pogoji uporabe',
    },
    contact: 'Kontakt',
    more: {
      title: 'Ve\u010D',
      floraFauna: 'Flora & Fauna',
    },
    sponsoredBy: 'S podporo',
    copyright: (year) => `\u00A9 ${year} TSCHAPP \u00B7 Vse pravice pridr\u017Eane`,
  },

  units: {
    minuteShort: 'min',
    hourShort: 'h',
  },

  mapMarkers: {
    ticketOffice: 'Blagajna',
    receptionHouse: 'Sprejemna hiša',
    goal: 'Cilj',
  },

  legend: {
    title: 'Legenda',
    mainRoute: 'Glavna pot',
    sideTrail: 'Stranska pot',
    waterways: 'Vodotoki',
    filterOnly: (kategorie: string) => `Prikaži samo ${kategorie}`,
    filterClear: 'Odstrani filter — prikaži vse',
    byDistance: 'Razdalja',
    byName: 'Ime',
  },

  nav: {
    home: 'Home',
    floraFauna: 'Flora & Fauna',
    routes: 'Hiking Trails',
    stories: 'Stories',
    login: 'Sign In',
    logout: 'Sign Out',
    myProfile: 'My Profile',
  },

  dialog: {
    register: {
      title: 'Registracija',
      description:
        'Pridru\u017Eite se skupnosti Tscheppaschlucht. Odkrijte naravo v raz\u0161irjeni resni\u010Dnosti.',
      nameLabel: 'Ime',
      namePlaceholder: 'Vaše ime',
      emailLabel: 'E-pošta',
      emailPlaceholder: 'ime@primer.com',
      passwordLabel: 'Geslo',
      passwordPlaceholder: 'Najmanj 8 znakov',
      submit: 'Ustvari račun',
      google: 'Registracija z Google',
      alreadyRegistered: '\u017De imate račun?',
      loginLink: 'Prijava',
      or: 'ali',
      emailSent: 'Poslali smo vam potrditev. Zdaj lahko nadaljujete!',
      emailHint: 'Obvestili vas bomo, ko bo TSCHAPP na voljo.',
    },
    login: {
      title: 'Prijava',
      description:
        'Ozna\u010Dite vrste, pustite komentarje in do\u017Eivite sotesko Tscheppaschlucht z drugimi ljubitelji narave.',
      emailLabel: 'E-pošta',
      emailPlaceholder: 'ime@primer.com',
      passwordLabel: 'Geslo',
      passwordPlaceholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022',
      submit: 'Prijava',
      google: 'Prijava z Google',
      noAccount: 'Še nimate računa?',
      registerLink: 'Registracija',
    },
    survey: {
      title: 'Kratka anketa',
      description: 'Pomagajte nam izbolj\u0161ati TSCHAPP \u2014 4 kratka vpra\u0161anja.',
      interestLabel: 'Kaj vas najbolj zanima?',
      interestOptions: {
        ar: 'AR do\u017Eivetje v naravi',
        flora: 'Odkrivanje flore & favne',
        routes: 'Pohodne poti',
        stories: 'Legende in zgodbe',
      },
      visitLabel: 'Kako pogosto obi\u0161\u010Dete Tscheppaschlucht?',
      visitOptions: {
        never: '\u0160e nikoli',
        once: '1\u20132-krat',
        regular: 'Redno',
        local: '\u017Divim v bli\u017Eini',
      },
      deviceLabel: 'Katero napravo uporabljate?',
      deviceOptions: {
        iphone: 'iPhone',
        android: 'Android',
      },
      wishLabel: 'Kaj bi si \u017Eeleli od aplikacije?',
      wishPlaceholder: 'Va\u0161e ideje (neobvezno)',
      submit: 'Po\u0161lji',
      skip: 'Presko\u010Di',
    },
  },

  navigation: {
    button: 'Navigacija',
    title: 'Zemljevid',
    close: 'Zapri zemljevid',
    centerOnUser: 'Centriraj na moj položaj',
    nearestPoint: 'Najbližja točka',
    distance: (meters) => meters < 1000 ? `${Math.round(meters)} m` : `${(meters / 1000).toFixed(1)} km`,
    learnMore: 'Več informacij',
    playAudio: 'Predvajaj zvok',
    locationPermissionDenied: 'Dostop do lokacije zavrnjen',
    loadingMap: 'Nalaganje zemljevida…',
    noGps: 'Ni GPS signala',

    loadFailed: 'Zemljevida ni bilo mogoče naložiti',
    aria: {
      zoomIn: 'Povečaj',
      zoomOut: 'Pomanjšaj',
      recenter: 'Centriraj na moj položaj',
      followEnable: 'Sledi mojemu položaju na zemljevidu',
      followDisable: 'Ustavi sledenje mojemu položaju',
    },
    aux: {
      storyGuideOpen: 'Odpri Story Guide',
      storyGuideClose: 'Zapri Story Guide',
      aiCompanionStart: 'Zaženi AI spremljevalca',
      aiCompanionPause: 'Ustavi AI spremljevalca',
      photoMap: 'Prikaži foto zemljevid',
      vectorMode: 'Vektorski način',
      diaryEnd: 'Zaključi dnevnik',
    },
    optionsSheet: {
      adventure: 'Pustolovščina',
      performance: 'Zmogljivost',
      map: 'Zemljevid',
      narrator: 'Pripovedovalec',
      voiceComing: 'Glas kmalu na voljo',
    },
    poiCard: {
      audioBtn: 'Zvok',
      audioStop: 'Ustavi',
      moreBtn: 'Več →',
      endBtn: 'Zaključi',
      metersAway: 'm stran',
      fromStart: 'od začetka',
      away: 'stran',
      sightLabel: 'Znamenitost',
    },
    // Routen-Karte (Picker) — Auswaehlen/Starten/Details (Alex 25.07.).
    /** Weggabelung: Routenwechsel direkt im Detail des Punktes
     *  (Alex 2026-08-11 — „wenn man da ist, will man vielleicht doch eine
     *  andere Route wandern"). */
    junction: {
      title: 'Od tu naprej',
      hint: 'Tu se poti razcepijo. Tapnite za zamenjavo poti.',
      active: 'Aktivna pot',
    },
    routeCard: {
      select: 'Izberi',
      active: 'Aktivna',
      start: 'Začni pot',
      details: 'Podrobnosti',
    },
  },

  // Entdecken-Oberflaeche. NUR Bedienelemente — POI-Titel, Beschreibungen
  // und Kategorien kommen sprachselektiert aus ArTrack/knowledge-api.
  discover: {
    title: 'Odkrijte',
    close: 'Zapri',
    back: 'Nazaj',
    searchPlaceholder: 'Iščite kraje, zgodbe, živali …',
    searchLabel: 'Iskanje po odkrivanju',
    categoryFilterLabel: 'Filtriraj po kategoriji',
    detailLabel: 'Podrobnosti kraja',
    unavailable: 'Ta kraj trenutno ni na voljo.',
    highlights: 'Poudarki',
    nearby: 'V bližini',
    allPlaces: 'Vsi kraji',
    categories: 'Kategorije',
    filterAll: 'Vse',
    unitSpecies: 'vrst',
    unitPlaces: 'krajev',
    heroSubtitle: 'Zgodbe, narava in skrivnosti soteske Tscheppaschlucht.',
    openMap: 'Odpri zemljevid',
    showAll: 'Prikaži vse',
    showOnMap: 'Na zemljevidu',
    readAloud: 'Preberi na glas',
    loading: 'Nalaganje vsebine …',
    nothingFound: (suche: string) => suche
      ? `Ni zadetkov za »${suche}«.`
      : `Ni zadetkov v tej kategoriji.`,
    stopReading: 'Ustavi branje',
  },

  footerNav: {
    profileSignIn: 'Profil — prijava',
    profile: 'Profil',
    map: 'Zemljevid',
    discover: 'Odkrij',
    chatBot: 'Dr. Tschauko',
    diary: 'Dnevnik',
    debug: 'Debug',
    route: 'Pot',
  },

  onboarding: {
    welcome: {
      title: 'Hvala za registracijo!',
      text: 'TSCHAPP vam pribli\u017Ea naravo soteske Tscheppaschlucht \u2014 z raz\u0161irjeno resni\u010Dnostjo, interaktivnimi zemljevidi in fascinantnimi zgodbami. Tukaj je kratek pregled.',
    },
    flora: {
      title: 'Flora & Favna',
      text: 'Odkrijte ve\u010D kot 80 avtohtonih \u017Eivalskih in rastlinskih vrst s podrobnimi opisi, 3D modeli in \u010Dlanki, ustvarjenimi z AI. Vsako vrsto lahko ozna\u010Dite in komentirate.',
    },
    stories: {
      title: 'Legende in zgodbe',
      text: 'Do\u017Eivite mite in legende soteske Tscheppaschlucht kot interaktivno zvočno knjigo \u2014 pripovedujeta na\u0161i maskoti Tschauko in Tschauka, ilustrirano z AI umetnostjo.',
    },
    routes: {
      title: 'Pohodne poti',
      text: 'Tri edinstvene poti vodijo skozi sotesko. Vsaka pot ima svoje postaje z AR do\u017Eivetji, vi\u0161inskimi profili in interaktivnimi 3D pogledi.',
    },
    next: 'Naprej',
    prev: 'Nazaj',
    skip: 'Presko\u010Di',
    start: 'Za\u010Dnimo',
  },

  expedition: {
    title: 'Moja ekspedicija',
    progress: (found, total) => `${found} od ${total} skrivnosti odkritih`,
    nextSecret: 'Poišči naslednjo skrivnost',
    nextSecretSub: 'Sledi naslednjemu namigu in odkrivaj sotesko.',
    today: 'Danes odkrito',
    newFound: 'Novo odkrito',
    nextHint: 'Naslednji namig',
    myFinds: 'Moje najdbe',
    secretSlot: 'Skrivnost',
    emptyRoute: 'Za to pot še ni zabeleženih skrivnosti.',
    badges: 'Značke',
    badgeTracker: { title: 'Sledilec', text: 'Najdeš namige, ki jih drugi spregledajo.' },
    badgePlants: { title: 'Poznavalec rastlin', text: 'Poznaš rastline soteske.' },
    missionTitle: 'Tvoja naloga',
    secretNofM: (n, m) => `Skrivnost ${n} od ${m}`,
    lookLike: 'Takole bi lahko izgledala',
    whatYouGet: 'Kaj dobiš',
    rewardFind: { title: 'Nova najdba', sub: 'Odkrij nekaj posebnega.' },
    rewardProgress: { title: '+1 napredek', sub: 'Tvoja ekspedicija raste.' },
    rewardSecret: { title: '1 skrivnost bližje', sub: 'Korak bližje rešitvi.' },
    rewardFindDone: 'Ta najdba je bila dodana v tvojo zbirko.',
    rewardSecretDone: 'Skrivnost rešena',
    lookout: 'Držim oči odprte',
    foundIt: 'Našel sem',
    later: 'Pozneje',
    fundTitle: 'Odlično odkritje',
    solvedNofM: (n, m) => `Skrivnost ${n} od ${m} rešena`,
    youFound: (name) => `Našel si: ${name}.`,
    progressLabel: 'Napredek ekspedicije',
    intoBook: 'V odkriteljsko knjigo',
    learnMore: 'Izvedi več',
  },

  forschung: {
    title: 'Raziskovalni dnevnik',
    subtitle: 'Zabeleži in razumi svoja opažanja.',
    newObservation: '+ Novo opažanje',
    statBeobachtungen: 'Opažanja',
    statArten: 'Vrste',
    statEntwuerfe: 'Osnutki',
    drafts: 'Osnutki',
    myEntries: 'Moji vnosi',
    emptyEntries: 'Še ni opažanj. Kar med potjo vidiš, slišiš ali najdeš, sodi sem.',
    untitled: 'Brez naslova',
    status: { draft: 'Osnutek', private: 'Zasebno', submitted: 'V pregledu', published: 'Objavljeno', rejected: 'Ni objavljeno', queued: 'Čaka na prenos', queuedRetry: 'Prenos se ponavlja' },
    newTitle: 'Novo opažanje',
    gpsPending: 'Kraj bo dodan, ko bo GPS na voljo.',
    capFoto: 'Fotografija',
    capMediathek: 'Knjižnica',
    capAudio: 'Zvok',
    capAudioStop: (s) => `${s}s stop`,
    capVideo: 'Video',
    mediaHint: (sec) => `Fotografije se za prenos samodejno pomanjšajo (HD). Videi: največ ${sec} sekund.`,
    videoTooLong: (sec, max) => `Video traja ${sec} sekund — dnevnik dovoljuje največ ${max} sekund, da prenos uspe tudi ob šibkem signalu.`,
    videoTooBig: (mb, max) => `Video je prevelik (${mb} MB). Posnemi največ ${max} sekund v HD.`,
    titleLabel: 'Naslov',
    noteLabel: 'Opomba',
    notePlaceholder: 'Kaj si opazil?',
    defaultTitleAt: (ort) => `Opažanje pri ${ort}`,
    defaultTitle: 'Opažanje',
    artLabel: 'Poveži vrsto (neobvezno)',
    artSearch: 'Išči ime vrste …',
    artUnlink: 'Odstrani povezavo',
    save: 'Shrani vnos',
    saveHint: 'Shranjeno zasebno — vidno samo tebi. Oddaja za skupnost je pozneje ločen korak.',
    back: 'Nazaj',
    suggest: 'Predlagaj za objavo',
    previewHeading: 'Tako bo videti tvoj prispevek',
    previewHint: 'Tvoj vnos bo pregledan, preden se pojavi v skupnosti.',
    submit: 'Oddaj vnos',
    submitting: 'Oddajanje …',
    keepPrivate: 'Obdrži zasebno',
    edit: 'Uredi',
    delete: 'Izbriši vnos',
    deleteConfirm: 'Dokončno izbrišem vnos?',
    keep: 'Obdrži',
    rejectedInfo: (reason) => `Uredništvo tega prispevka ni objavilo${reason ? `: ${reason}` : '.'} Tvoj zasebni vnos ostaja.`,
    submitFailed: (detail) => `Oddaja ni uspela — vnos ostaja zasebno shranjen. (${detail})`,
    queuedInfo: (attempts) => `Oddano — prenos steče, takoj ko bo povezava${attempts ? ` (doslej ${attempts} poskusov)` : ''}. Aplikacijo lahko zapreš; ob naslednjem odprtju bo poskusila znova.`,
    backToList: 'Nazaj na pregled',
    fallbackOrt: 'Tscheppaschlucht',
    community: 'Iz soteske',
    communitySub: 'Skupnost odkriva, deli in ohranja.',
  },
}
